import {
  CALL_ORIGIN_TARGETED_OFFERS,
  EMAIL_ID,
  LOYALTY_ID,
} from 'contexts/CruiseSearchContext/constants';
import Cookies from 'js-cookie';

import { BrandCode } from 'types';
import { validateFormatLoyaltyIdEmail } from './validateFormatLoyaltyIdEmail';

export const validateFormatInvalidLoginTargetedOffer = ({
  updateState,
  globalization,
  input,
  brand,
}) => {
  const { filtersDictionary } = globalization.dictionaries;
  const {
    errorMyOffersInvalidCrownAndAnchorSocietyID_RCI,
    errorMyOffersInvalidCrownAndAnchorSocietyID_CEL,
    errorMyOffersInvalidEmai,
  } = filtersDictionary;

  const errorMyOffersInvalidID = {
    [BrandCode.RoyalCaribbean]: [errorMyOffersInvalidCrownAndAnchorSocietyID_RCI],
    [BrandCode.Celebrity]: [errorMyOffersInvalidCrownAndAnchorSocietyID_CEL],
  };
  
  const { loyaltyID, email, originLoyalty, originEmail } = input;
  let loginValidation = validateFormatLoyaltyIdEmail(loyaltyID, email);

  if (
    (loyaltyID && !loginValidation.loyaltyID) ||
    (email && !loginValidation.email)
  ) {
    updateState({
      errorTargetedOfferMessage: loyaltyID
        ? errorMyOffersInvalidID[brand]
        : errorMyOffersInvalidEmai,
      isInvalidEmailOrCASId: true,
      loyaltyIDOrEmailLogin: loyaltyID || email,
      targetedOffersLoading: false,
      targetedOffersLoaded: true,
    });
    if (
      loyaltyID &&
      !loginValidation.loyaltyID &&
      originLoyalty === CALL_ORIGIN_TARGETED_OFFERS.COOKIE
    ) {
      Cookies.remove(LOYALTY_ID.cookie);
    }
    if (
      email &&
      !loginValidation.email &&
      originEmail === CALL_ORIGIN_TARGETED_OFFERS.COOKIE
    ) {
      Cookies.remove(EMAIL_ID.cookie);
    }
  }
  return loginValidation;
};
